import { render, staticRenderFns } from "./PayoutsRejected.vue?vue&type=template&id=86964fe2&scoped=true&"
import script from "./PayoutsRejected.vue?vue&type=script&lang=js&"
export * from "./PayoutsRejected.vue?vue&type=script&lang=js&"
import style0 from "./PayoutsRejected.vue?vue&type=style&index=0&id=86964fe2&lang=scss&scoped=true&"
import style1 from "./PayoutsRejected.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86964fe2",
  null
  
)

export default component.exports